// extracted by mini-css-extract-plugin
module.exports = {"container":"container___3Pkvz","color":"color___1T1nC","left":"left___25ppZ"};